import React from 'react';
import { Database } from '../../server/database';
import { BsFillXCircleFill } from 'react-icons/bs';
import './Modal.css'
import './BannerListModal.css'
import { Server } from '../../server/server';

interface BannerListModalProps {
  onClose: Function;
}

class BannerListModal extends React.Component<BannerListModalProps, {}> {
  render() {
    let banners = Server.user.getAssetsByCategory('banner');

    banners.sort((a, b)=>{
      if(a.name < b.name)
        return -1;
      else if(a.name > b.name)
        return 1;
      return 0;
    })

    let rows:any[] = [];

    if(banners.length == 0) {
      rows.push(<div key={0}>You do not own any banners yet.</div>);
    }
    else {
      for(let i = 0; i < banners.length; i++) {
        let src = `/assets/${banners[i].id}.png`;
        rows.push(
          <div key={i} style={{marginRight:'6px'}} onClick={()=>this.props.onClose(banners[i].id)}>
            <img src={src} className="banner-list-modal-row"/>
          </div>
        );
      }
    }

    return (
      <div className="modal open">
        <div className="modal-content banner-list-modal-content">
          <button className="modal-close-button" onClick={()=>this.props.onClose()}>
            <BsFillXCircleFill />
          </button>
          <div className="banner-list-modal-header">Select Banner</div>
          <div className="banner-list-modal-container">
            {rows}
          </div>
        </div>
      </div>
    )
  }
}

export default BannerListModal;